import { JetView } from 'webix-jet';

/**
 * Class representing the details view for a withdrawal request.
 * @extends JetView
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the layout of the withdrawal request details view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information section configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // ID field
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'), // Type field
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Date field
                    labelPosition: 'top',
                    placeholder: _('Fecha'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'), // Amount field
                    labelPosition: 'top',
                    placeholder: _('Monto'),
                    disabled: true, // Field is disabled
                    id: 'Monto', // Unique ID for the Amount field
                },
            ],
        };

        // Secondary main information section configuration
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'), // Payment system name field
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'),
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Right main section configuration
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info],
        };

        // Upper section configuration with multiview
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main],
        };

        // Narrow upper section configuration for small screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow], // Conditional layout based on screen size
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            form.setValues(person); // Set form values based on selected person
            this.$$('Monto').setValue(webix.i18n.priceFormat(person.Amount)); // Format and set the Amount field
        });
    }
}

// FILE DOCUMENTED
